import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white py-12 px-4 sm:px-6 lg:px-8 transition-colors duration-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="flex flex-col items-start md:items-start">
            <div className="flex flex-col items-start md:items-center">
              <div className="mb-0.5 flex flex-col items-start md:items-center">
                <Link to="/" className="group flex flex-col items-start md:items-center font-['Jost'] font-light uppercase tracking-[0.3em] text-xl sm:text-2xl transition-all">
                  <span className="text-white">BROOKS</span>
                  <span className="text-emerald-400 font-normal">FLOWER</span>
                </Link>
              </div>
              <p className="text-gray-400 text-left md:text-center text-lg font-light">Spread love, embrace love</p>
            </div>
          </div>

          <div>
            <ul className="list-none space-y-2 text-gray-400">
              <li>
                <Link
                  to="/shop?category=all"
                  className="hover:text-white transition-colors"
                >
                  All Flowers
                </Link>
              </li>
              <li>
                <Link
                  to="/shop?category=bouquets"
                  className="hover:text-white transition-colors"
                >
                  Bouquets
                </Link>
              </li>
              <li>
                <Link
                  to="/shop?category=gifts"
                  className="hover:text-white transition-colors"
                >
                  Gifts
                </Link>
              </li>
              <li>
                <Link
                  to="/shop?category=others"
                  className="hover:text-white transition-colors"
                >
                  Others
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <ul className="list-none space-y-2 text-gray-400">
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <ul className="list-none space-y-2 text-gray-400">
              <li>
                <a
                  href="https://www.instagram.com/brooks_flower_?igsh=MXBhOWZrZm9zbDBwcg%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/251930241300"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/brooksflower1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  Telegram
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@brooksflower1?_r=1&_d=e5jfjll30l68fa&sec_uid=MS4wLjABAAAAw3VsVsSilriZDCSDef8acwhMURgQAexFGeGkNv2-JhdSKaskLL2Xqt-Hy5phsO3W&share_author_id=7537626615937958917&sharer_language=en&source=h5_m&u_code=elllhakm6mb9gd&item_author_type=1&utm_source=copy&tt_from=copy&enable_checksum=1&utm_medium=ios&share_link_id=37AF20C5-953A-4085-B719-4ADB056856E2&user_id=7537626615937958917&sec_user_id=MS4wLjABAAAAw3VsVsSilriZDCSDef8acwhMURgQAexFGeGkNv2-JhdSKaskLL2Xqt-Hy5phsO3W&social_share_type=4&ug_btm=b8727,b0&utm_campaign=client_share&share_app_id=1233"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 Brooks Flower. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
